import config from "../../config";

export const redirectGcpCreation = (
  customerId: string,
  siteId: string,
  isPilot: boolean,
) => {
  const url = isPilot
    ? config.pilotAppUrl + `#gcp-${customerId}:${siteId}`
    : config.projectsAppUrl +
      `/ongoing-projects/${customerId}/${siteId}?upload-gcp-coordinates`;

  window.location.href = url;
};
